import PropTypes from 'prop-types';
import React, { useState } from 'react';
import VerificationCode from 'views/MFA/CodeVerification/VerificationCode';
import PhoneNumberInput from 'views/MFA/PhoneNumberInput/PhoneNumberInput';
import Reauthenticate from 'views/Reauthenticate/Reauthenticate';
import ChangePhone from './ChangePhone';

function ChangePhoneMFA({ noReset = false }) {
  const [resolver, setResolver] = useState(null);
  const [userCredentials, setUserCredentials] = useState(null);
  const [verificationId, setVerificationId] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  return userCredentials ? (
    <ChangePhone
      userCredentials={userCredentials}
      setResolver={setResolver}
      setUserCredentials={setUserCredentials}
      resolver={resolver}
    />
  ) : !resolver && !userCredentials ? (
    <Reauthenticate
      setResolver={setResolver}
      setUserCredentials={setUserCredentials}
    />
  ) : verificationId === '' ? (
    <PhoneNumberInput
      resolver={resolver}
      setVerificationId={setVerificationId}
      setPhoneNumber={setPhoneNumber}
      noReset={noReset}
    />
  ) : (
    <VerificationCode
      resolver={resolver}
      verificationId={verificationId}
      phoneNumber={phoneNumber}
      setUserCredentials={setUserCredentials}
      newPhone
    />
  );
}

ChangePhoneMFA.propTypes = {
  noReset: PropTypes.bool
};

export default ChangePhoneMFA;
